// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchPopUp_wrapper__hYpX+","products":"SearchPopUp_products__J3zj0"};